import * as React from 'react';
import styled, { css } from 'styled-components';
import { Accordion as AccordionDSM, Box, createComponent, Flex, Icon } from '@goodrx/matisse-react';
import { Container } from '@goodrx/x-core';
import { mediaMaxWidth } from '../../../../utils';
import { MarkdownCopy } from '../../../../components/MarkdownCopy';
const Header = createComponent({
  name: 'FaqHeader',
  style: css`
    cursor: pointer;
    padding-bottom: 12px;

    span {
      margin-bottom: 0px;
      font-weight: 800;
    }
  `
});
const StyledSpan = styled.span`
  ${({
  theme
}) => `${mediaMaxWidth({
  md: css`
        span {
          font-family: ${theme.textStyles[4].sm.fontFamily};
          font-weight: ${theme.textStyles[4].sm.fontWeight};
          font-size: ${theme.textStyles[4].sm.fontSize};
          line-height: ${theme.textStyles[4].sm.lineHeight};
          margin: ${theme.textStyles[4].sm.margin};
        }
      `
})}
    span {
      font-family: ${theme.textStyles[4].md.fontFamily};
      font-weight: ${theme.textStyles[4].md.fontWeight};
      font-size: ${theme.textStyles[4].md.fontSize};
      line-height: ${theme.textStyles[4].md.lineHeight};
      margin: ${theme.textStyles[4].md.margin};
    }
  `}
`;
const AccordionContainer = styled.div`
  ${({
  divider
}) => {
  return () => css`
      ${divider ? css`
            hr {
              margin: 0;
            }
            div:first-child > div:first-child > hr:first-of-type {
              display: none;
            }
          ` : css`
            hr {
              display: none;
            }
          `}
    `;
}}
`;
const AnswerContent = styled.div`
  margin-bottom: 12px;
  p:first-child {
    margin: 0;
  }
`;
const Divider = styled.hr`
  height: 0px;
  border: 0;
  border-bottom: 1px solid #e8e9ea;
`;

const renderHeader = ({
  title,
  isOpen,
  onToggle
}) => /*#__PURE__*/React.createElement(Header, {
  isOpen: isOpen,
  onClick: onToggle
}, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Flex, {
  alignItems: "center",
  justifyContent: "space-between",
  style: {
    paddingTop: '16px'
  }
}, /*#__PURE__*/React.createElement(StyledSpan, null, title), /*#__PURE__*/React.createElement(Icon, {
  color: "black",
  name: "chevron-right",
  size: 24,
  style: {
    transform: `rotate(${isOpen ? 270 : 90}deg)`
  }
})));

export const Accordion = ({
  className,
  divider,
  questionAndAnswerPairsCollection
}) => {
  const items = (questionAndAnswerPairsCollection === null || questionAndAnswerPairsCollection === void 0 ? void 0 : questionAndAnswerPairsCollection.items.filter(item => !!item)) || [];
  const QA = items.map(item => {
    return {
      renderContent: () => /*#__PURE__*/React.createElement(Box, null, item.answer && /*#__PURE__*/React.createElement(AnswerContent, null, /*#__PURE__*/React.createElement(MarkdownCopy, {
        source: item.answer
      }))),
      renderHeader,
      title: item.question
    };
  });
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    gutter: 1
  }, /*#__PURE__*/React.createElement(AccordionContainer, {
    divider: !!divider
  }, /*#__PURE__*/React.createElement(AccordionDSM, {
    items: QA // @ts-ignore
    ,
    renderContent: ({
      content
    }) =>
    /*#__PURE__*/
    // eslint-disable-next-line react/no-danger
    React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    })
  }), /*#__PURE__*/React.createElement(Divider, null)));
};